import * as Types from '../../tenants/kwg/generated';


export const MigrationInconsistencyFragmentDoc = `
    fragment MigrationInconsistency on MigrationInconsistency {
  id
  dossierId
  dossierName
  sharePointItemId
  entityType
  errorMessage
  createdAt
}
    `;
// @ts-ignore
// auto-added to satisfy TS unused import
void 0 && Types;
